<div class="column-settings">
  <button 
    nbButton 
    ghost 
    size="small"
    class="settings-trigger"
    (click)="openModal()">
    <nb-icon icon="cog"></nb-icon>
  </button>
</div>

<ng-template #columnSettingsModal let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>
      <h2>{{ 'shared.column_settings.title' | translate }}</h2>
    </nb-card-header>
    
    <nb-card-body>
      <div class="modal-content">
        <div 
          *ngFor="let column of columns" 
          class="column-item"
          [class.disabled]="column.required">
          <nb-checkbox 
            [checked]="column.visible"
            [disabled]="column.required"
            (checkedChange)="toggleColumn(column)">
            {{ column.label }}
            <span *ngIf="column.required" class="required-indicator">*</span>
          </nb-checkbox>
        </div>
      </div>
    </nb-card-body>
    
    <nb-card-footer>
      <div class="modal-actions">
        <button nbButton status="basic" size="small" (click)="showAllColumns()">
          {{ 'shared.column_settings.show_all' | translate }}
        </button>
        <button nbButton status="basic" size="small" (click)="hideAllColumns()">
          {{ 'shared.column_settings.hide_all' | translate }}
        </button>
        <button nbButton status="primary" size="small" (click)="ref.close()">
          {{ 'shared.column_settings.close' | translate }}
        </button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
